import Vue from "vue";
import VueRouter from "vue-router";
import { getCookie } from "@/utils/CookieUtils";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/login.vue"),
  },
  {
    path: "*",
    name: "main",
    component: () => import("@/views/index.vue"),
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "hash",
  routes,
});

router.beforeEach((to, from, next) => {
  //全局钩子函数
  to.matched.some((route) => {
    if (route.name === "Login") {
      next();
    } else {
      if (getCookie("accessToken") !== "") {
        next();
      } else {
        next({ name: "Login", params: { path: route.path } });
      }
    }
  });
});

export default router;
